/* Scoped carousel; Shopify reconnects this element after section edits. */
if (!customElements.get('kr-style-it')) {
  customElements.define('kr-style-it', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.boards = [...this.querySelectorAll('.kr-si-board')];
      this.dots = [...this.querySelectorAll('[data-board-index]')];
      this.index = 0;
      this.request = 0;
      this.controls = this.querySelector('.kr-si-controls');
      this.mobileLayout = window.matchMedia('(max-width: 749px)');
      this.mobileLayout.addEventListener('change', () => this.positionControls(), options);
      this.positionControls();
      this.addEventListener('click', event => {
        const direction = event.target.closest('[data-direction]');
        const dot = event.target.closest('[data-board-index]');
        if (direction) this.go(this.index + Number(direction.dataset.direction));
        if (dot) this.go(Number(dot.dataset.boardIndex));
      }, options);
      this.addEventListener('keydown', event => {
        if (/INPUT|TEXTAREA|SELECT/.test(event.target.tagName) || event.target.isContentEditable) return;
        if (this.boards.length < 2) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      const viewport = this.querySelector('.kr-si-viewport');
      let origin;
      viewport.addEventListener('pointerdown', event => {
        if (event.isPrimary && event.button === 0) origin = {x: event.clientX, y: event.clientY};
      }, options);
      viewport.addEventListener('pointerup', event => {
        if (!origin) return;
        const dx = event.clientX - origin.x, dy = event.clientY - origin.y;
        origin = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) this.go(this.index + (dx < 0 ? 1 : -1));
      }, options);
      viewport.addEventListener('pointercancel', () => { origin = null; }, options);
      viewport.addEventListener('pointerleave', () => { origin = null; }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.boards.findIndex(board => board.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.go(index);
      }, options);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.load(0); this.load(1); this.load(this.boards.length - 1);
          this.observer.disconnect();
        }
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.request++;
    }
    positionControls() {
      if (!this.controls) return;
      const focused = this.controls.contains(document.activeElement) ? document.activeElement : null;
      const before = this.mobileLayout.matches
        ? this.boards[this.index]?.querySelector('.kr-si-rugline')
        : this.querySelector('[data-board-status]');
      if (before && this.controls.nextElementSibling !== before) {
        before.parentNode.insertBefore(this.controls, before);
        focused?.focus({preventScroll:true});
      }
    }
    load(index) {
      const board = this.boards[index];
      if (!board) return Promise.resolve();
      return Promise.all([...board.querySelectorAll('img')].map(image => {
        if (image.dataset.src) {
          image.src = image.dataset.src;
          delete image.dataset.src;
        }
        return image.decode().catch(() => {});
      }));
    }
    async go(index) {
      const length = this.boards.length;
      if (!length) return;
      index = (index + length) % length;
      const request = ++this.request;
      await this.load(index);
      if (!this.isConnected || request !== this.request || index === this.index) return;
      const focusedControl = this.controls?.contains(document.activeElement) ? document.activeElement : null;
      const old = this.boards[this.index];
      if (old.contains(document.activeElement)) this.focus({preventScroll:true});
      old.classList.remove('is-active');
      old.setAttribute('aria-hidden', 'true');
      old.inert = true;
      this.index = index;
      const current = this.boards[index];
      current.classList.add('is-active');
      current.setAttribute('aria-hidden', 'false');
      current.inert = false;
      this.positionControls();
      focusedControl?.focus({preventScroll:true});
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.querySelector('[data-board-status]').textContent = current.getAttribute('aria-label');
      this.load((index + 1) % length);
      this.load((index - 1 + length) % length);
    }
  });
}
